import { UuidUtil } from '@elderbyte/ngx-starter'
import { DynamicPropertySpec } from './dynamic-property-spec'
import { DynamicPropertyConf } from './dynamic-property-conf'
import { PropertySpec } from '../spec/property-spec'
import { PropertyConf } from '../conf/property-conf'
import { ConstraintSpec } from '../../process/capability-spec/constraints/constraint-spec'
import { ConstraintConf } from '../../shopfloor/workcenters/capability/constraints/constraint-conf'

export class DynamicPropertyMaterializer {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private _spec: DynamicPropertySpec
  private _description: string

  public static start(spec: DynamicPropertySpec): DynamicPropertyMaterializer {
    return new DynamicPropertyMaterializer(spec)
  }

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(spec: DynamicPropertySpec) {
    this._spec = spec
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public description(description: string): DynamicPropertyMaterializer {
    this._description = description
    return this
  }

  public materialize(): DynamicPropertyConf {
    return <DynamicPropertyConf>{
      id: UuidUtil.strongUuid4(),
      dynamicPropertySpecId: this._spec.id,
      spec: this._spec, // transient
      description: this._description,
      conditions: this._spec.conditions.map((c) => this.materializeConstraint(c)),
      properties: this._spec.properties.map((p) => this.materializeProperty(p)),
    }
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private materializeConstraint(spec: ConstraintSpec): ConstraintConf {
    const constraint = new ConstraintConf()
    constraint.spec = spec
    constraint.constraintSpecId = spec.id
    constraint.values = []

    return constraint
  }

  private materializeProperty(spec: PropertySpec): PropertyConf {
    const property = new PropertyConf()
    property.propertyId = spec.propertyId
    property.property = spec.property

    property.values = []

    property.spec = spec

    return property
  }
}
